import React from "react";

export default function Rename() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 7H6C5.46957 7 4.96086 7.21071 4.58579 7.58579C4.21071 7.96086 4 8.46957 4 9V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 14.9963H12L20.5 6.49632C20.697 6.29934 20.8532 6.06548 20.9598 5.80811C21.0665 5.55074 21.1213 5.2749 21.1213 4.99632C21.1213 4.71774 21.0665 4.4419 20.9598 4.18453C20.8532 3.92716 20.697 3.6933 20.5 3.49632C20.303 3.29934 20.0692 3.14308 19.8118 3.03648C19.5544 2.92987 19.2786 2.875 19 2.875C18.4374 2.875 17.8978 3.0985 17.5 3.49632L9 11.9963V14.9963Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 5L19 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
